import './assets/styles/main.scss';
import ReportRoutes from './routes';

export default ReportRoutes;
